/** Sets the request state for the given user setting identifiers. */
export function setUserRequestState(state, identifiers, requestState) {
  for (const identifier of identifiers) {
    state.user.requestStateByIdentifier[identifier] = requestState;
  }
}